import { render, staticRenderFns } from "./setNewSalaryTemp.vue?vue&type=template&id=46c8cdbf&scoped=true&"
import script from "./setNewSalaryTemp.vue?vue&type=script&lang=js&"
export * from "./setNewSalaryTemp.vue?vue&type=script&lang=js&"
import style0 from "./setNewSalaryTemp.vue?vue&type=style&index=0&id=46c8cdbf&prod&lang=scss&scoped=true&"
import style1 from "./setNewSalaryTemp.vue?vue&type=style&index=1&id=46c8cdbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c8cdbf",
  null
  
)

export default component.exports